"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23.81,8.44a.5.5,0,0,0-.37-.18H22.9a3.61,3.61,0,0,0-3.72-3.5H19A3.82,3.82,0,0,0,17.68,5,6,6,0,0,0,6.25,5,3.85,3.85,0,0,0,5,4.78,3.58,3.58,0,0,0,1,8q0,.15,0,.29H.49a.5.5,0,0,0-.37.18.47.47,0,0,0-.11.4l1.61,10a2.89,2.89,0,0,0,1.85,2.21v-.32a3.49,3.49,0,0,1,7,0,2.71,2.71,0,0,1,0,.5h3.11a2.69,2.69,0,0,1,0-.5,3.49,3.49,0,0,1,7,0v.32a2.85,2.85,0,0,0,1.84-2.21L24,8.85A.47.47,0,0,0,23.81,8.44ZM2,8.27A2.58,2.58,0,0,1,4.67,5.76l.3,0a2.87,2.87,0,0,1,1.37.34.55.55,0,0,0,.45,0,.5.5,0,0,0,.32-.35,5,5,0,0,1,9.77,0,.5.5,0,0,0,.27.35.55.55,0,0,0,.45,0A2.87,2.87,0,0,1,19,5.78,2.61,2.61,0,0,1,21.91,8q0,.12,0,.25Z"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "6.97",
    cy: "20.73",
    r: "2.5"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "16.94",
    cy: "20.73",
    r: "2.5"
  }));
};

exports["default"] = _default;